// Import Libraries
import React from 'react';
import PageSEO from '../../../../Components/SEO/PageSEO';
import styles from './ContactPage.module.scss';

// Import Components
import HeroComponent from '../../../../Layout/Components/HeroComponent/HeroComponent';
import ContactComponent from './Components/ContactComponent/ContactComponent';

// Import Animation
import FadeInOnScroll from '../../../../util/Animations/FadeInOnScroll';

const ContactPage = () => {
  // Define structured data for contact information
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "WebNX",
    "url": "https://webnx.com",
    "description": "Enterprise internet infrastructure provider offering dedicated servers, colocation services, and 24/7 technical support.",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "sales",
        "telephone": "+1-800-840-5996",
        "email": "sales@webnx.com",
        "areaServed": "US",
        "availableLanguage": "English",
        "contactOption": "TollFree",
        "hoursAvailable": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59"
      },
      {
        "@type": "ContactPoint",
        "contactType": "technical support",
        "telephone": "+1-800-840-5996",
        "email": "support@webnx.com",
        "areaServed": "US",
        "availableLanguage": "English",
        "contactOption": "TollFree",
        "hoursAvailable": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59"
      },
      {
        "@type": "ContactPoint",
        "contactType": "billing",
        "telephone": "+1-800-840-5996",
        "email": "sales@webnx.com",
        "areaServed": "US",
        "availableLanguage": "English",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "contactType": "abuse",
        "email": "abuse@webnx.com",
        "areaServed": "US",
        "availableLanguage": "English"
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "119 N 600 W",
      "addressLocality": "Ogden",
      "addressRegion": "UT",
      "postalCode": "84404",
      "addressCountry": "US"
    },
    "location": [
      {
        "@type": "Place",
        "name": "WebNX Ogden Data Center",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Ogden",
          "addressRegion": "UT",
          "addressCountry": "US"
        }
      },
      {
        "@type": "Place",
        "name": "WebNX Los Angeles Data Center",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Los Angeles",
          "addressRegion": "CA",
          "addressCountry": "US"
        }
      },
      {
        "@type": "Place",
        "name": "WebNX Manhattan Data Center",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Manhattan",
          "addressRegion": "NY",
          "addressCountry": "US"
        }
      }
    ],
    "sameAs": [
      "https://www.facebook.com/WebNX/",
      "https://www.linkedin.com/company/webnx/"
    ],
    "potentialAction": {
      "@type": "ContactAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://clients.webnx.com/submitticket.php?step=2&deptid=6",
        "description": "Submit Support Ticket",
        "name": "Support Ticket System"
      }
    }
  };

  return (
    <>
      <PageSEO
        title="Contact WebNX | 24/7 Support & Sales | Enterprise Hosting Solutions"
        description="Contact WebNX for dedicated server support, sales inquiries, or technical assistance. Available 24/7/365 via phone, email, or support ticket system. Get expert help for your enterprise hosting needs."
        keywords="contact WebNX, WebNX support, dedicated server support, hosting support, technical support, server sales, colocation support, enterprise hosting support, WebNX contact information, WebNX phone number"
        path="/contact"
        image="https://webnx.com/assets/contact-webnx.jpg"
        schema={contactSchema}
        socialProfiles={{
          facebook: "https://www.facebook.com/WebNX/",
          linkedin: "https://www.linkedin.com/company/webnx/"
        }}
      />

      <main className={styles.main}>
        <FadeInOnScroll>
          <section>
            <ContactComponent />
          </section>
        </FadeInOnScroll>
      </main>
    </>
  );
};

export default ContactPage;
